const audioPlayerStyle = Object.freeze({
  fontStack: 'base',

});

export default audioPlayerStyle;
